module.exports = __webpack_public_path__ + "static/media/arrow-circle-left.70c33b76.svg";